<template>
  <get-started :title="title">
    <loading-page v-if="fetchingServices" />
    <b-row
      v-else
      align-h="center"
    >
      <b-col
        lg="6"
        class="text-center my-5"
      >
        <template v-if="!servicesFetched">
          <GjIcon
            name="InfoAlt"
            class="icon-left"
          />
          Something went wrong. Please try again later.
        </template>
        <template v-else>
          <p>
            Permissions are required in order to use this service or feature.
          </p>
          <button-loading
            variant="primary"
            class="mt-1"
            :spinning="requestingService || serviceRequested"
            :disabled="requestingService || serviceRequested"
            @click="requestPermission"
          >
            Request permissions
          </button-loading>
        </template>
      </b-col>
    </b-row>
  </get-started>
</template>
<script>
import GetStarted from './GetStarted.vue'

export default {
  name: 'RequestService',
  components: { GetStarted },
  props: {
    title: {
      type: String,
      default: 'Service Requires Permission',
    },
    name: {
      type: String,
      required: true,
    },
    serviceRequested: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    servicesFetched() {
      return this.$store.state.captianServices.servicesFetched
    },
    fetchingServices() {
      return this.$store.state.captianServices.fetchingServices
    },
    services() {
      return this.$store.state.captianServices.services
    },
    serviceId() {
      return this.services.find(el => el.name === this.name).id || null
    },
    requestingService() {
      return this.$store.state.organization.updatingOrganization
    },
  },
  created() {
    if (!this.servicesFetched && !this.fetchingServices) {
      this.$store.dispatch('captianServices/fetchServices').catch(() => {})
    }
  },
  methods: {
    requestPermission() {
      this.$store
        .dispatch('organization/updateOrganization', {
          serviceId: this.serviceId,
        })
        .catch(() => {})
    },
  },
}
</script>
